import { Box, Typography, Container, Button } from "@mui/material";
import Script from "next/script";

export default function Home() {
    return (
        <>
            <Script
                async
                id="ze-snippet"
                src="https://static.zdassets.com/ekr/snippet.js?key=c4edb3bf-6a0e-4ec6-8625-7d8728a5d40f"
            ></Script>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                    width: "100vw",
                    background: (theme) =>
                        theme.palette.mode === "light"
                            ? `linear-gradient(135deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[100]} 100%)`
                            : theme.palette.background.default,
                }}
            >
                <Container maxWidth="sm">
                    <Box
                        sx={{
                            textAlign: "center",
                            py: 8,
                            px: 4,
                        }}
                    >
                        <Box
                            component="img"
                            src="https://tickets.authentigate.ca/uploads/28/ag-black-transparent.png"
                            alt="AuthentiGATE"
                            sx={{
                                width: 280,
                                maxWidth: "90%",
                                mb: 4,
                                filter: (theme) =>
                                    theme.palette.mode === "dark"
                                        ? "invert(100%)"
                                        : "none",
                            }}
                        />
                        <Typography
                            variant="body1"
                            sx={{
                                color: "text.secondary",
                                lineHeight: 1.8,
                                maxWidth: 500,
                                mx: "auto",
                                mb: 4,
                            }}
                        >
                            Looking for tickets to an event? Use the store link
                            provided by the event organizer to browse and
                            purchase tickets. If you need assistance, click the{" "}
                            <Box
                                component="span"
                                sx={{
                                    fontWeight: 600,
                                    fontStyle: "italic",
                                    color: "primary.main",
                                }}
                            >
                                Help
                            </Box>{" "}
                            button below.
                        </Typography>
                        <Button
                            variant="contained"
                            href="https://authentigate.ca"
                            target="_blank"
                            rel="noopener"
                        >
                            Learn More About AuthentiGATE
                        </Button>
                    </Box>
                </Container>
            </Box>
        </>
    );
}
